module.exports = __webpack_public_path__ + "static/media/brewery.1a22778c.svg";